export const ICONS = [
	'fa fa-archive',
	'fa fa-arrows',
	'fa fa-arrows-h',
	'fa fa-arrows-v',
	'fa fa-balance-scale',
	'fa fa-ban',
	'fa fa-bath',
	'fa fa-bed',
	'fa fa-battery',
	'fa fa-beer',
	'fa fa-bell',
	'fa fa-bicycle',
	'fa fa-birthday-cake',
	'fa fa-blind',
	'fa fa-bolt',
	'fa fa-book',
	'fa fa-bug',
	'fa fa-briefcase',
	'fa fa-building',
	'fa fa-bullhorn',
	'fa fa-bus',
	'fa fa-calendar',
	'fa fa-camera',
	'fa fa-car',
	'fa fa-certificate',
	'fa fa-child',
	'fa fa-circle',
	'fa fa-circle-o',
	'fa fa-cloud',
	'fa fa-coffee',
	'fa fa-close',
	'fa fa-comment',
	'fa fa-comments',
	'fa fa-compass',
	'fa fa-cutlery',
	'fa fa-deaf',
	'fa fa-desktop',
	'fa fa-envelope',
	'fa fa-exclamation',
	'fa fa-exclamation-triangle',
	'fa fa-eye',
	'fa fa-eyedropper',
	'fa fa-female',
	'fa fa-fire',
	'fa fa-fire-extinguisher',
	'fa fa-flag',
	'fa fa-frown-o',
	'fa fa-flask',
	'fa fa-gamepad',
	'fa fa-gavel',
	'fa fa-gift',
	'fa fa-glass',
	'fa fa-globe',
	'fa fa-group',
	'fa fa-hand-stop-o',
	'fa fa-headphones',
	'fa fa-heart',
	'fa fa-history',
	'fa fa-home',
	'fa fa-heartbeat',
	'fa fa-hourglass',
	'fa fa-info',
	'fa fa-lock',
	'fa fa-magnet',
	'fa fa-male',
	'fa fa-map',
	'fa fa-microphone',
	'fa fa-meh-o',
	'fa fa-minus-circle',
	'fa fa-mobile',
	'fa fa-music',
	'fa fa-pencil',
	'fa fa-paint-brush',
	'fa fa-paw',
	'fa fa-phone',
	'fa fa-picture-o',
	'fa fa-plug',
	'fa fa-recycle',
	'fa fa-shower',
	'fa fa-shopping-bag',
	'fa fa-shopping-basket',
	'fa fa-shopping-cart',
	'fa fa-smile-o',
	'fa fa-snowflake-o',
	'fa fa-star',
	'fa fa-street-view',
	'fa fa-suitcase',
	'fa fa-thermometer',
	'fa fa-thumb-tack',
	'fa fa-thumbs-down',
	'fa fa-thumbs-up',
	'fa fa-tablet',
	'fa fa-television',
	'fa fa-tint',
	'fa fa-times-circle',
	'fa fa-trash',
	'fa fa-tree',
	'fa fa-umbrella',
	'fa fa-user',
	'fa fa-volume-up',
	'fa fa-wifi',
	'fa fa-wheelchair',
	'fa fa-wrench',
	'fa fa-scissors',
	'fa fa-medkit',
	'fa fa-stethoscope',
	'fa fa-ambulance',
	'fa fa-euro',
	'fa fae-snowing',
	'fa fae-soda',
	'fa fae-sofa',
	'fa fae-soup',
	'fa fae-spermatozoon',
	'fa fae-stomach',
	'fa fae-storm',
	'fa fae-telescope',
	'fa fae-thermometer',
	'fa fae-thermometer-high',
	'fa fae-thermometer-low',
	'fa fae-toilet',
	'fa fae-tools',
	'fa fae-virus',
	'fa fae-shirt',
	'fa fae-tacos',
	'fa fae-sushi',
	'fa fae-triangle-ruler',
	'fa fae-sun-cloud',
	'fa fae-ruler',
	'fa fae-umbrella',
	'fa fae-medicine',
	'fa fae-microscope',
	'fa fae-milk-bottle',
	'fa fae-molecule',
	'fa fae-moon-cloud',
	'fa fae-mustache',
	'fa fae-palette-color',
	'fa fae-pizza',
	'fa fae-plant',
	'fa fae-poison',
	'fa fae-popcorn',
	'fa fae-popsicle',
	'fa fae-pulse',
	'fa fae-radioactive',
	'fa fae-raining',
	'fa fae-real-heart',
	'fa fae-refrigerator',
	'fa fae-restore',
	'fa fae-ring',
	'fa fae-fingerprint',
	'fa fae-footprint',
	'fa fae-galery',
	'fa fae-glass',
	'fa fae-gut',
	'fa fae-halter',
	'fa fae-hamburger',
	'fa fae-hat',
	'fa fae-hotdog',
	'fa fae-ice-cream',
	'fa fae-id-card',
	'fa fae-layers',
	'fa fae-lips',
	'fa fae-lipstick',
	'fa fae-liver',
	'fa fae-lung',
	'fa fae-wallet',
	'fa fae-chesse',
	'fa fae-chilli',
	'fa fae-chip',
	'fa fae-cicling',
	'fa fae-cloud',
	'fa fae-cockroach',
	'fa fae-coffe-beans',
	'fa fae-coins',
	'fa fae-comb',
	'fa fae-dice',
	'fa fae-dna',
	'fa fae-donut',
	'fa fae-dress',
	'fa fae-drop',
	'fa fae-wind',
	'fa fae-bacteria',
	'fa fae-banana',
	'fa fae-bath',
	'fa fae-bed',
	'fa fae-bones',
	'fa fae-book-open-o',
	'fa fae-brain',
	'fa fae-bread',
	'fa fae-carot',
	'fa fae-checklist-o',
	'fa fae-cherry',
	'fa fae-apple-fruit',
	'fa fae-chicken-thigh',
	'fa fae-injection',
	'fa fae-lollipop',
	'fa fae-meat',
	'fa fae-orange',
	'fa fae-pear'
];
